import Link from 'next/link';

export default function AsideNavLink(props) {
    const { className, href, children, active, hr, target } = props;

    let classNameContent = "block border-l-3 text-bb no-underline pl-30 pr-20 py-10";
    let hrContent; // small horizontal rule

    if (active) {
        classNameContent = classNameContent + " border-cc text-cc";
    } else {
        classNameContent = classNameContent + " border-grey hover:underline";
    }

    if (hr && !active) {
        hrContent = (
            <span className="block bg-grey"></span>
        );
    }

    return (
        <>
            { hrContent }
            <Link
                href={ href }
                scroll={ false }
                className={ classNameContent + (className ? " " + className : "") }
                target={ target }
            >
                { children }
            </Link>
        </>
    );
}